export const BlindsClose = () => (
  <svg
    width="59"
    height="58"
    viewBox="0 0 59 58"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <filter
        x="-25%"
        y="-14.4%"
        width="150%"
        height="151.1%"
        filterUnits="objectBoundingBox"
        id="6gsq8gjy1a"
      >
        <feOffset dy="5" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="3" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0.407843137 0 0 0 0 0.607843137 0 0 0 0 0.878431373 0 0 0 0.24 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <rect id="aqphx3bovb" x="1.408" y="2" width="46" height="45" rx="16" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(5)">
        <use fill="#000" filter="url(#6gsq8gjy1a)" xlinkHref="#aqphx3bovb" />
        <use fill="#FFF" xlinkHref="#aqphx3bovb" />
      </g>
      <g fill="#2396FD">
        <path d="m29.164 30.3 9.1-13.3h-18.2zM20.064 34.5h18.2v-4.2h-18.2z" />
      </g>
    </g>
  </svg>
);
